export default __webpack_public_path__ + "images/models/25da735fabc5ba9bce87445d8465bb1b.glb";